import React, { ReactNode, memo, useEffect, useState } from "react";
import { Form, Input, Typography } from "antd";
import { getRegexForValidation } from "../../utils/getRegexForValidation";

const { Text } = Typography;
interface Props {
  title?: string;
  placeholder: string;
  onChange?: any;
  disabled?: boolean;
  value: any
  className?: string;
  rules?: any,
  suffix?: any,
  control?: any,
  name?: any,
  autoFocus?: boolean,
  prefix?: ReactNode
}
const InputComponent: React.FC<Props> = ({
  title,
  placeholder,
  onChange,
  disabled,
  value,
  className,
  rules,
  suffix,
  // control,
  name,
  autoFocus = false,
  prefix
}) => {

  const pattern: RegExp = getRegexForValidation(rules?.allowValues).value;
  const [error, setError] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleChange = (e: any) => {

    setInputValue(e.target.value);
    if (onChange) {
      onChange(e);
    }

    if (e.target.value.length > 0) {
      if (pattern.test(e.target.value)) {
        setError(false);
      } else {
        setError(true);
      }
    }

  };


  return (
    <>
      <Form.Item
        
        label={title}
        name={name}
        rules={[
          {
            required: true, message: "Please enter the value"
          }, {
            pattern: pattern, message: "Please enter a valid input"
          }
        ]}
      >
        <Input
          type={rules?.allowValues === 'numeric' ? 'number' : 'text'}
          // name={name}
          placeholder={placeholder}
          prefix={prefix}
          onChange={handleChange}
          disabled={disabled}
          value={inputValue}
          className={className}
          maxLength={name === 'email' ? 50 : rules?.maxSize}
          minLength={rules?.minSize}
          suffix={suffix}
          required
          autoFocus={autoFocus}
        />
      </Form.Item>

      {(error) && (
        <div className="my-1 ml-2 pl-1 text-right">
          <Text type="danger">Please enter a valid input</Text>
        </div>
      )}
    </>


  );
};

export default memo(InputComponent);
